import styled from 'styled-components';

export const LoadingPanelWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10000;
  left: 0;
  display: flex;
  align-items: center;
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  background-color: rgba(255, 255, 255, 0.4);
  inset: 0px;
  position: absolute;
  pointer-events: auto;
  cursor: pointer;
`;

export const LoadingSpinnerWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
`;
